// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconInformation: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="currentColor">
            <path
                fill="#53ACDB"
                d="M21,30 C25.9702148,30 30,25.9716679 30,21 C30,16.0312382 25.9702148,12 21,12 C16.0297852,12 12,16.0312382 12,21 C12,25.9716679 16.0297852,30 21,30 Z M21,19.0403226 C20.1581992,19.0403226 19.4758065,18.3579298 19.4758065,17.516129 C19.4758065,16.6743282 20.1581992,15.9919355 21,15.9919355 C21.8418008,15.9919355 22.5241935,16.6743282 22.5241935,17.516129 C22.5241935,18.3579298 21.8418008,19.0403226 21,19.0403226 Z M22.5967742,25.6451613 L19.4032258,25.6451613 C19.1627315,25.6451613 18.9677419,25.4501717 18.9677419,25.2096774 L18.9677419,24.3387097 C18.9677419,24.0982154 19.1627315,23.9032258 19.4032258,23.9032258 L19.8387097,23.9032258 L19.8387097,21.5806452 L19.4032258,21.5806452 C19.1627315,21.5806452 18.9677419,21.3856556 18.9677419,21.1451613 L18.9677419,20.2741935 C18.9677419,20.0336993 19.1627315,19.8387097 19.4032258,19.8387097 L21.7258065,19.8387097 C21.9663007,19.8387097 22.1612903,20.0336993 22.1612903,20.2741935 L22.1612903,23.9032258 L22.5967742,23.9032258 C22.8372685,23.9032258 23.0322581,24.0982154 23.0322581,24.3387097 L23.0322581,25.2096774 C23.0322581,25.4501717 22.8372685,25.6451613 22.5967742,25.6451613 Z"
                transform="translate(-12 -12)"
            />
        </svg>
    );
};

export default React.memo(IconInformation);
